// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2zIip","info":"UpdateTermsInfo_info__3YLYm"};